export enum UserTypeEnum {
  TCA = 'TCA',
  TCV = 'TCV'
}

export enum MerchantTypeEnum {
  TC = 'TC'
}

export enum AccessControlTypeEnum {
  UMA = 'UMA',
  RMA = 'RMA',
  VLMA = 'VLMA',
  VAMA = 'VAMA',
  DA = 'DA',
  SAMA = 'SAMA',
  SLMA = 'SLMA',
  CMA = 'CMA',
  MDA = 'MDA',
  BTA = 'BTA',
  BBA = 'BBA',
  VWLA = 'VWLA',
  CLA = 'CLA',
  RARA = 'RARA'
}

export enum LeadStatusTypeEnum {
  BOOKED = 'BOOKED',
  INQUIRY = 'INQUIRY'
}
